import controller from "assets/images/controller.png";
import main_logo from "assets/images/landing/main_logo.png";
import games_library from "assets/images/summary/games_library.png";
import classic_games from "assets/images/summary/classic_games.jpg";
import game_controller from "assets/images/summary/game_controller.png";
import audio from "assets/images/summary/audio.png";
import competitive_gaming from "assets/images/summary/competitive_gaming.jpg";
import family_gaming from "assets/images/summary/family_gaming.jpg";
import healthline from "assets/images/summary/healthline.png";
import business_insider from "assets/images/summary/business_insider.png";
import newYorkTimes from "assets/images/summary/newYorkTimes.png";
import bbc from "assets/images/summary/bbc.png";
import our_promise from "assets/images/summary/our_promise.jpg";
import signature from "assets/images/summary/signature.png";
import gaming_service_user from "assets/images/quiz/gaming_service_user.jpg";
import gaming_service_user_before from "assets/images/quiz/gaming_service_user_before.jpg";
import pc_owner from "assets/images/quiz/pc_owner.jpg";
import console_owner from "assets/images/quiz/console_owner.jpg";
import cloud_gaming from "assets/images/quiz/cloud_gaming.png";
import intermision_one from "assets/images/quiz/intermision_one.jpg";
import intermision_two from "assets/images/quiz/intermision_two.jpg";
import gaming_plan from "assets/images/checkout/gaming_plan.jpeg";
import nintendo_assets from "assets/images/checkout/nintendo_assets.png";
import gaming_journey_1 from "assets/images/checkout/gaming_journey_1.jpg";
import gaming_journey_2 from "assets/images/checkout/gaming_journey_2.png";
import gaming_journey_3 from "assets/images/checkout/gaming_journey_3.jpg";
import experience from "assets/images/checkout/experience.png";
import faq from "assets/images/checkout/faq.jpg";
import safe_checkout from "assets/images/checkout/safe_checkout.png";
import congratulations from "assets/images/success/congratulations.jpg";

export const images: Record<string, string> = {
  controller,
  main_logo,
  games_library,
  classic_games,
  game_controller,
  audio,
  competitive_gaming,
  family_gaming,
  healthline,
  business_insider,
  newYorkTimes,
  bbc,
  our_promise,
  signature,
  gaming_service_user,
  gaming_service_user_before,
  pc_owner,
  console_owner,
  cloud_gaming,
  intermision_one,
  intermision_two,
  gaming_plan,
  nintendo_assets,
  gaming_journey_1,
  gaming_journey_2,
  gaming_journey_3,
  experience,
  faq,
  safe_checkout,
  congratulations,
};
